import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { QPointSidebarService, } from '../../projects/qpoint-layout/src/lib/components/sidebar/sidebar.service/sidebar.service';
import { IWorkspace, QPointWorkspaceSelectionComponent } from '../../projects/qpoint-layout/src/lib/components/workspace-selection/workspace-selection.component';
import { SidebarBadgesService } from './services/sidebar-badges.service';
import { QPointMapsLoader } from '../../projects/qpoint-maps/src/lib/services/maps-loader.service';
import { ThemeService } from '../../projects/qpoint-theme/src/lib/theme/theme.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QPointUserInfoComponent } from '../../projects/qpoint-layout/src/lib/components/user-info/user-info.component';
import { QPointSidebarComponent } from '../../projects/qpoint-layout/src/lib/components/sidebar/sidebar.component';
import { QPointMainComponent } from '../../projects/qpoint-layout/src/lib/components/main/main.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [QPointMainComponent, QPointSidebarComponent, QPointUserInfoComponent, QPointWorkspaceSelectionComponent, RouterOutlet]
})
export class AppComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  public workspaces: IWorkspace[];
  public selectedWorkspace: IWorkspace;
  public isMenuDisabled = false;

  constructor (
    private sidebarService: QPointSidebarService,
    private router: Router,
    private translateService: TranslateService,
    private sidebarBadgesService: SidebarBadgesService,
    private mapsService: QPointMapsLoader,
    private themeService: ThemeService) {
    this.workspaces = [
      { id: '1', name: 'Eurovia Industrie GmbH - Standord Neufelden', imageSrc: 'https://picsum.photos/100/100' },
      { id: '2', name: 'Eurovia Industrie GmbH - Standord Neufelden mit Extras', imageSrc: 'https://picsum.photos/100/100' },
      { id: '3', name: 'Test3' }
    ];
    this.selectedWorkspace = this.workspaces[0];
    this.mapsService.initMap();
  }

  public setDarkmode() {
    this.themeService.setDarkMode();
  }
  public setLightMode() {
    this.themeService.setLightMode();
  }

  setSystemDefault() {
    this.themeService.setSystemMode();
  }
  public ngOnInit() {
    // timer(10000).subscribe(() => alert('sers'));
    this.themeService.apply();
    for (let _i = 3; _i < 50; _i++) {
      this.workspaces.push({ id: _i.toString(), name: 'test' + _i });
    }
    this.translateService.setDefaultLang('en-US');

    this.sidebarService.registerBadgeSubject('main', this.sidebarBadgesService.myBadgeSubject);
    this.sidebarService.registerBadgeSubject('gallery', this.sidebarBadgesService.myBadgeSubject);

    this.sidebarService.menuDisabledChanged
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(isDisabled => {
        this.isMenuDisabled = isDisabled;
      }); 
  }

  public addNewWorkspace () {
    console.log('addNewWorkspace');
  }

  public selectedWorkspaceSettings () {
    console.log('selectedWorkspaceSettings');
  }

  public selectWorkspace (event) {
    console.log('selectWorkspace', event);
  }

  public navigateToLegal (): void {
    this.router.navigate(['legal']);
  }

  myAccountClick () {
    this.router.navigateByUrl('/profile');
  }

}
